import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/* Legacy /news/original/:id links -> permanent redirect to the clean /news/:slug URL. */
export default function NewsOriginal() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isError } = useQuery({
    queryKey: ["news-original-legacy", id],
    queryFn: () => api.get(`/news/originals/${id}`).then((r) => r.data.original),
    retry: false,
  });

  useEffect(() => {
    if (data?.slug) navigate(`/news/${data.slug}`, { replace: true });
    else if (isError) navigate("/news", { replace: true });
  }, [data, isError, navigate]);

  return (
    <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 md:px-8 md:pt-48" data-testid="news-original-redirect">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Taking you to the story…</p>
    </main>
  );
}
